import { render, staticRenderFns } from "./quarterly.vue?vue&type=template&id=63ab7720&scoped=true&"
import script from "./quarterly.vue?vue&type=script&lang=js&"
export * from "./quarterly.vue?vue&type=script&lang=js&"
import style0 from "./quarterly.vue?vue&type=style&index=0&id=63ab7720&lang=scss&scoped=true&"
import style1 from "./quarterly.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ab7720",
  null
  
)

export default component.exports